// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"b95b49325d694ad74393","263":"1d4d7c11936c15c062ec","791":"3e54832209d738bf7e02"}[chunkId] + ".js";
};